export const catalog = (name = 'catalog', seed = []) => {
    const obj = {};
    let loaded = false;
    let state = [];

    const load = () => {
        const local = localStorage.getItem(name);
        if (local == null) localStorage.setItem(name, JSON.stringify(seed));
        state = local ? JSON.parse(local) : seed;
        loaded = true;
    };

    const update = () => {
        localStorage.setItem(name, JSON.stringify(state));
    };

    obj.all = () => {
        if (!loaded) load();
        return state;
    };

    obj.find = (id) => {
        return obj.all().find((item) => item.id == id);
    };

    obj.add = (item) => {
        state = [...obj.all(), item];
        update();
    };

    obj.update = (id, data) => {
        state = obj.all().map((item) => (item.id == id ? { id, ...data } : item));
        update();
    };

    obj.remove = (id) => {
        state = obj.all().filter((item) => item.id != id);
        update();
    };

    return obj;
};

const hex = (value) => {
    return Math.floor(value).toString(16);
};

export const objectId = () => {
    const timestamp = hex(Date.now() / 1000);
    const random = ' '.repeat(16).replace(/./g, () => hex(Math.random() * 16));
    return timestamp + random;
};
